import { useEffect, useState, useRef } from 'react';
import React from 'react';
import './descubre.css';
import { useTranslation } from "react-i18next";

import back_i from '../../../assets/imgs/libro_bitcoin/fondo-bitcoin-left-low.png';
import back_d from '../../../assets/imgs/libro_bitcoin/fondo-bitcoin-right-low.png';


const Descubre = () => {
    const [lang, setLang] = useState(localStorage.getItem('language') || 'es');
    const [langText, setLangText] = useState(lang === 'es' ? 'English' : 'Español');
    const [t, i18n] = useTranslation("libroBitcoin");
    const [isPlaying, setIsPlaying] = useState(false);
    const videoRef = useRef(null);
    const isYouTube = (url) => url.includes('youtube.com') || url.includes('youtu.be');

    const [current, setCurrent] = useState(0);

    const dataEs = [
        {
            title: t('videos.vid1'),
            duration: '30:07',
            videoUrl: 'https://www.youtube.com/embed/PYs-xQ8s1CQ?si=VGwUjGyH5aU?cc_load_policy=1&autoplay=1',
            poster: 'https://ricardosalinas.com/video/bitcoin-maxres3.jpg',
            
        },
        {
            title: 'LA ILUMINACIÓN DE BITCOIN - Teaser',
            duration: '00:39',
            videoUrl: 'https://ricardosalinas.com/video/RBS_LIDB__Teaser_Español_Horizontal.mp4',
            poster: 'https://ricardosalinas.com/video/teaser-bit-poster-es.jpg', // imagen de fondo
        }
    ];

    const dataEn = [
        {
            title: t('videos.vid1'),
            duration: '30:07',
            videoUrl: 'https://www.youtube.com/embed/PYs-xQ8s1CQ?si=VGwUjGyH5aU?cc_load_policy=1&autoplay=1',
            poster: 'https://ricardosalinas.com/video/bitcoin-maxres3.jpg',
        },
        {
            title: 'THE BITCOIN ENLIGHTENMENT - Teaser',
            duration: '00:39',
            videoUrl: 'https://ricardosalinas.com/video/Teaser_Bitcoin Book_V3.mp4',
            poster: 'https://ricardosalinas.com/video/teaser-bit-poster-min.jpg', // imagen de fondo
        }
    ];

    const data = i18n.language === "es" ? dataEs : dataEn;

    const prev = () => {
        setCurrent((prevIndex) => (prevIndex === 0 ? data.length - 1 : prevIndex - 1));
    };

    const next = () => {
        setCurrent((prevIndex) => (prevIndex === data.length - 1 ? 0 : prevIndex + 1));
    };

    const handlePlay = () => {
        window.gtag('event', 'click', {
            event_category: 'Interacción',
            event_label: 'Video Play',
            value: 1
        });
        setIsPlaying(true);
    };

    useEffect(() => {
        const currentVideo = data[current];
        if (isPlaying && videoRef.current && !isYouTube(videoUrl)) {
            // Necesario para evitar error al cambiar rápido de slide
            const playPromise = videoRef.current.play();
            if (playPromise !== undefined) {
                playPromise.catch(error => {
                    console.warn('Video play error:', error);
                });
            }
        }
    }, [isPlaying, current]);

    useEffect(() => {
        setIsPlaying(false); // detiene la reproducción anterior y muestra poster
    }, [current]);

    const videoUrl = data[current].videoUrl;

    return (
        <>
            <div className="landing_bitcoin_descubre">
                <div className="landing_bitcoin_descubre_content">
                    <div className='esp-content'></div>

                    <div className='slider-div'>
                        <h4 dangerouslySetInnerHTML={{ __html: (t('descubre.titulo')) }}></h4>

                        <div className="slider-card">
                            <div className="slider-image-wrapper">
                                {isPlaying ? (
                                    isYouTube(videoUrl) ? (
                                        <iframe
                                            src={data[current].videoUrl}
                                            title={data[current].title}
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                            className="slider-video slider-video-iframe-yb"
                                        ></iframe>
                                    ) : (
                                        <video
                                            ref={videoRef}
                                            src={data[current].videoUrl}
                                            controls
                                            className="slider-video"
                                            poster={data[current].poster}
                                        />
                                    )
                                ) : (
                                    <>
                                        <img
                                            src={data[current].poster}
                                            alt={data[current].title}
                                            className="slider-poster"
                                        />
                                        <button className="slider-play" onClick={handlePlay}>▶</button>
                                    </>
                                )}
                            </div>

                            <div className="slider-footer">
                                <span className="slider-title">{data[current].title}</span>
                                <span className="slider-duration">🕒 {data[current].duration}</span>
                            </div>
                        </div>

                        <div className="slider-nav">
                            <button onClick={prev}>←</button>
                            <div className="slider-dots">
                                {data.map((_, index) => (
                                    <span
                                        key={index}
                                        className={`dot ${index === current ? 'active' : ''}`}
                                    ></span>
                                ))}
                            </div>
                            <button onClick={next}>→</button>
                        </div>
                    </div>

                    <div className='esp-content'>
                        <div className="slider-counter">{current + 1} →</div>
                    </div>
                </div>

                <img className="landing_bitcoin_descubre_img_i" src={back_i} alt="Fondo izquierdo" />
                <img className="landing_bitcoin_descubre_img_d" src={back_d} alt="Fondo derecho" />
            </div>
        </>
    );
}

export default Descubre